import {otherRouter, appRouter} from '../../router/router';
import Util from '../../libs/util';
import Cookies from 'js-cookie';
import Vue from 'vue';
import PageName from '../../constant/PageName'
import * as Cache from '../../cache/Cache'

const app = {
    state: {
        //isFirstLogin: false,
        avatorImgPath:'',
        cachePage: [],
        lang: '',
        isFullScreen: false,
        openedSubmenuArr: [], // 要展开的菜单数组
        menuTheme: 'dark', // 主题
        themeColor: '',
        pageOpenedList: [{
            title: '首页',
            path: '',
            name: PageName.PAGE_HOME_INDEX
        }],
        currentPageName: '',
        currentPath: [
            {
                title: '首页',
                path: '',
                name: PageName.PAGE_HOME_INDEX
            }
        ], // 面包屑数组
        menuList: [],
        routers: [
            otherRouter,
            ...appRouter
        ],
        tagsList: [...otherRouter.children],
        messageCount: 0,
        dontCache: ['text-editor', 'artical-publish'] // 在这里定义你不想要缓存的页面的name属性值(参见路由配置router.js)
    },
    mutations: {
        toggleFirstLogin (state,status) {
            state.isFirstLogin = status
        },
        updateMenulist (state) {
            //菜单权限配置
            let permissionsInfo = Cache.getPermissions();
            let permissions = permissionsInfo ? permissionsInfo : [];

            let menuList = [];
            appRouter.forEach((item, index) => {
                let len = menuList.push(item);
                let childrenArr = [];
                childrenArr = item.children.filter(child => {
                    if (child.permissionId !== undefined) {
                        if (Util.isHavePermission(child.permissionId, permissions)) {
                            return child;
                        }
                    } else {
                        return child;
                    }
                });
                if (childrenArr === undefined || childrenArr.length === 0) {
                    menuList.splice(len - 1, 1);
                } else {
                    let handledItem = JSON.parse(JSON.stringify(menuList[len - 1]));
                    handledItem.children = childrenArr;
                    menuList.splice(len - 1, 1, handledItem);
                }
            });
            state.menuList = menuList;
        },
        clearMenuList(state){
            let menuList=[];
            state.menuList = menuList;
        },
        closePage (state, name) {
            state.cachePage.forEach((item, index) => {
                if (item === name) {
                    state.cachePage.splice(index, 1);
                }
            });
        },
        initCachepage (state) {
            if (localStorage.cachePage) {
                state.cachePage = JSON.parse(localStorage.cachePage);
            }
        },
        pageOpenedList (state, get) {
            let openedPage = state.pageOpenedList[get.index];
            if (get.argu) {
                openedPage.argu = get.argu;
            }
            if (get.query) {
                openedPage.query = get.query;
            }
            state.pageOpenedList.splice(get.index, 1, openedPage);
            localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
        },
        setCurrentPath (state, pathArr) {
            state.currentPath = pathArr;
        },
        setCurrentPageName (state, name) {
            state.currentPageName = name;
        },
        setAvator (state, path) {
            localStorage.avatorImgPath = path;
        },
        clearOpenedSubmenu (state) {
            state.openedSubmenuArr.length = 0;
        },
        increateTag (state, tagObj) {
            if (!Util.oneOf(tagObj.name, state.dontCache)) {
              //判断是否已经添加到缓存中了
              let isExist = false;
              state.cachePage.forEach((item)=>{
                if(item === tagObj.name) {
                  isExist = true;
                }
              })
              //缓存中不存在，则添加
              if(!isExist) {
                state.cachePage.push(tagObj.name);
                localStorage.cachePage = JSON.stringify(state.cachePage);
              }
            }
            state.pageOpenedList.push(tagObj);
            localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
        }
    }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js